import React from "react"
import { Box, Themed } from "theme-ui"

const About = () => (
  <Box sx={{ my: 5 }}>
    <Themed.p>I create products for the web.</Themed.p>
    <Themed.p>
      I am deeply interested in problems of collective behavior and future
      models of open scientific collaboration.
    </Themed.p>
    <Themed.p>
      My work since 2011 has focused on designing and building open source
      platforms which enable people to visualize and interactively explore high
      dimensional spaces.
    </Themed.p>
    <Themed.p>
      I love backpacking, surfing and parenting 3 boys. I travel frequently and
      love seeing new places.
    </Themed.p>
  </Box>
)

export default About
